import {
    Control,
    DivIcon,
    FitBoundsOptions,
    Icon,
    LatLngBoundsExpression,
    LatLngExpression,
    LatLngLiteral,
    Layer,
    LayerGroup,
    Map as LeafletMapType,
    MapOptions,
    Marker,
    MarkerClusterGroup,
    MarkerOptions,
    Polyline,
    PolylineOptions,
    Popup,
    PopupOptions,
    LocateOptions
} from 'leaflet';

export type ControlType = Control;
export type ControlLayersType = Control.Layers;
export type ControlLayersObjectType = Control.LayersObject;
export type FitBoundsOptionsType = FitBoundsOptions;
export type IconType = Icon | DivIcon;
export type LatLngType = LatLngLiteral;
export type LatLngPolylinePointType = LatLngExpression;
export type LatLngPolylineType = LatLngPolylinePointType[];
export type LatLngBoundsType = LatLngBoundsExpression;
export type LayerGroupType = LayerGroup;
export type LayerType = Layer | ControlLayersType;
export type MapOptionsType = MapOptions;
export type MapType = LeafletMapType;
export type MarkerClusterGroupType = MarkerClusterGroup;
export type MarkerType = Marker;
export type MarkerOptionsType = MarkerOptions;
export type PopupType = Popup;
export type PopupOptionsType = PopupOptions;
export type PolylineType = Polyline;
export type PolylineOptionsType = PolylineOptions;

export type MapLayersSettingsOption = {
    name: string;
    label: string;
    layer: Layer;
};

export interface MapIconConfig {
    size: number;
    anchor: [number, number];
}

export const MapEvents = {
    zoomEnd: 'zoomend',
    moveEnd: 'moveend'
};

export interface ExtendedLocateOptions extends LocateOptions {
    showPopup?: boolean;
    clickBehavior?: {
        inView?: 'setView' | 'stop';
        inViewNotFollowing?: 'stop' | 'setView';
        outOfView?: 'stop' | 'setView';
    };
    onLocationError?: (err: Error) => void;
    position?: string;
}

export interface LatLngEventType {
    latlng: LatLngType;
}

export interface LayerGroupMap {
    [name: string]: LayerGroupType;
}

export enum LayerStylesConfig {
    Streets = 'streets',
    Satellite = 'satellite',
    Hybrid = 'satellite-streets'
}

export const LayerStyles = {
    [LayerStylesConfig.Streets]: 'streets-v12',
    [LayerStylesConfig.Satellite]: 'satellite-v9',
    [LayerStylesConfig.Hybrid]: 'satellite-streets-v12'
} as const;

type LayerStylesKeys = keyof typeof LayerStyles;
export type LayerStylesValues = (typeof LayerStyles)[LayerStylesKeys];

export const LayerStylesTranslations = {
    [LayerStylesConfig.Streets]: 'MAP_TILE_STYLE_STREETS',
    [LayerStylesConfig.Satellite]: 'MAP_TILE_STYLE_SATELLITE',
    [LayerStylesConfig.Hybrid]: 'MAP_TILE_STYLE_HYBRID'
};

export interface ClusterStylingOptions {
    containerClass?: string;
    wrapperClass?: string;
    spanClass?: string;
}
